const GTM_ID = "GTM-WRJS543R";

// Inyecta Google Tag Manager solo cuando hay consentimiento analítico
export const initGA = () => {
  if (window.google_tag_manager && window.google_tag_manager[GTM_ID]) return; // Evitar duplicados

  // 1. Script para el <head>
  const script = document.createElement("script");
  script.innerHTML = `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${GTM_ID}');
  `;
  document.head.appendChild(script);

  console.log("Google Tag Manager inyectado por consentimiento de cookies.");
};

// Registra los cambios de página para GTM / GA4
export const logPageView = (path) => {
  if (window.dataLayer) {
    window.dataLayer.push({
      event: 'pageview',
      page: path
    });
  }
};